import { render } from "./app-wallet.vue?vue&type=template&id=094b16e5&scoped=true"
import script from "./app-wallet.vue?vue&type=script&lang=js"
export * from "./app-wallet.vue?vue&type=script&lang=js"

import "./app-wallet.vue?vue&type=style&index=0&id=094b16e5&lang=scss&scoped=true"
import "./app-wallet.vue?vue&type=style&index=1&id=094b16e5&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094b16e5"]])

export default __exports__